import React from "react";

interface BillableIconProps {
  checked?: boolean;
  className?: string;
}

export default function BillableIcon({
  checked = false,
  className,
}: BillableIconProps) {
  if (checked) {
    return (
      <svg
        width="30"
        height="17"
        viewBox="0 0 30 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <rect width="30" height="17" rx="8.5" fill="#5A8DF1" />
        <circle cx="21.5" cy="8.5" r="6.5" fill="white" />
        <path
          d="M21.1618 12.85V12.08C19.5418 11.96 18.7418 11.03 18.7218 9.72H19.8318C19.8518 10.65 20.3618 11.24 21.5418 11.24C22.4918 11.24 23.1418 10.87 23.1418 10.09C23.1418 9.23 22.6718 8.98 21.3118 8.73C19.7918 8.46 18.8818 8.01 18.8818 6.7C18.8818 5.51 19.7418 4.74 21.1618 4.64V3.86H21.8218V4.64C23.2118 4.76 24.0218 5.58 24.0418 6.76H22.9418C22.9118 5.88 22.3118 5.46 21.4318 5.46C20.5318 5.46 20.0018 5.89 20.0018 6.56C20.0018 7.37 20.5218 7.53 21.8518 7.78C23.0918 8 24.2618 8.31 24.2618 9.99C24.2618 11.17 23.4218 11.99 21.8218 12.08V12.85H21.1618Z"
          fill="#5A8DF1"
        />
      </svg>
    );
  }

  return (
    <svg
      width="30"
      height="17"
      viewBox="0 0 30 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="30" height="17" rx="8.5" fill="#79808A" />
      <circle cx="8.5" cy="8.5" r="6.5" fill="white" />
      <path
        d="M8.16176 12.85V12.08C6.54176 11.96 5.74176 11.03 5.72176 9.72H6.83176C6.85176 10.65 7.36176 11.24 8.54176 11.24C9.49176 11.24 10.1418 10.87 10.1418 10.09C10.1418 9.23 9.67176 8.98 8.31176 8.73C6.79176 8.46 5.88176 8.01 5.88176 6.7C5.88176 5.51 6.74176 4.74 8.16176 4.64V3.86H8.82176V4.64C10.2118 4.76 11.0218 5.58 11.0418 6.76H9.94176C9.91176 5.88 9.31176 5.46 8.43176 5.46C7.53176 5.46 7.00176 5.89 7.00176 6.56C7.00176 7.37 7.52176 7.53 8.85176 7.78C10.0918 8 11.2618 8.31 11.2618 9.99C11.2618 11.17 10.4218 11.99 8.82176 12.08V12.85H8.16176Z"
        fill="#79808A"
      />
    </svg>
  );
}
